import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employee',
  'Employment Status',
  'Employment Type',
  'Location',
  'Manager',
  'Time Off Type'
];

class TimeOffBalancesReport extends React.Component {
  render() {
    return (
      <CompositeReport dateFilter='single' filters={filters}>
        <Report name={t('reports.TIME_OFF_BALANCES_REPORT')}
                url='/reports/time_off_summary'>
        </Report>
      </CompositeReport>
    );
  }
}

export default TimeOffBalancesReport;
